module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/ledger-account-grid/ledger-account-grid.component.css
// module id = ./src/app/masters/ledger-account-grid/ledger-account-grid.component.css
// module chunks = main